const initialState = [];
const reducerPartnerTaxRates = (state = initialState, action) => {
	let newState = [...state];
	switch (action.type) {
		case 'RECEIVE_PARTNER_TAX_RATES':
			if (action.data) {
				newState = action.data.map(tr => ({
					...tr,
					tax_rate: parseFloat(tr.tax_rate * 100).toFixed(2),
				}));
			}
			return newState;
		case 'EDIT_PARTNER_TAX_RATES':
			if (action.prefix && action.product_type) {
				if (action.rate != null) {
					const i = newState.findIndex(
						tr =>
							tr.partner_prefix === action.prefix &&
							tr.product_type == action.product_type
					);
					if (i === -1) {
						newState.push({
							partner_prefix: action.prefix,
							order_type: 3,
							product_type: action.product_type,
							tax_rate: action.rate,
						});
					} else {
						newState[i].tax_rate = action.rate;
					}
				} else {
					newState = newState.filter(
						tr =>
							tr.partner_prefix === action.prefix &&
							tr.product_type != action.product_type
					);
				}
			}
			return newState;
		default:
			return newState;
	}
};

export default reducerPartnerTaxRates;
